import React from 'react';

import './index.css';

const LoadingOverlay = () => {
    return (
        <div className="loading-overlay"></div>
    );
};

export default LoadingOverlay;


// WEBPACK FOOTER //
// ./src/components/LoadingOverlay/index.js